import React, { Fragment } from 'react';
import Spinner from 'react-spinkit';
import ProductGrid from '../ProductGrid';
import Pagination from './Pagination';
import { pluralize } from '../../utils';
import padding from 'scy/padding.mod.scss';
import margin from 'scy/margin.mod.scss';
import { textCenter } from 'scy/utils.mod.scss';
import { H5 } from 'scy/text';

export default function CategoryProductsList({
  loading,
  products,
  itemCount,
  offset,
  pageSize,
  pathForOffset
}) {
  return (
    <>
      {loading ? (
        <div className={`${padding.xl} ${textCenter}`}>
          <Spinner spinnerName="three-bounce" />
        </div>
      ) : (
        <Fragment>
          <ProductGrid className={padding.tablet_top_sm} products={products} />

          {!!itemCount && (
            <div className={`${padding.md} ${textCenter}`}>
              <H5 tag="div" marginClass={`${margin.top_0} ${margin.bottom_sm}`}>
                {itemCount} {pluralize('Product', itemCount)}
              </H5>
              <Pagination
                itemCount={itemCount}
                offset={offset}
                pageSize={pageSize}
                pathForOffset={pathForOffset}
              />
            </div>
          )}
        </Fragment>
      )}
    </>
  );
}
